let goodsConfig: GoodsConfig = {
    singleGoodsDefaultWidth: 10,
    singleGoodsDefaultHeight: 20,
    keyMap: {
        //陈列位
        usePartition: "cubeData.usePartition",
        audFlag: "cubeData.audFlag",
        audMsg: "cubeData.audMsg",
        unitType: "cubeData.unitType",
        boxSpec: "cubeData.boxSpec",
        boxSpecList: "cubeData.boxSpecList",
        surfaceWidth: "cubeData.surfaceWidth",
        surfaceHeight: "cubeData.surfaceHeight",
        surfaceDepth: "cubeData.surfaceDepth",
        referSurfaceDepth: "cubeData.referSurfaceDepth",
        posX: "cubeData.posX",
        posY: "cubeData.posY",
        posZ: "cubeData.posZ",
        posWidth: "cubeData.posWidth",
        hangnailId: "cubeData.hangnailId",
        posDirection: "cubeData.posDirection",
        posCapacity: "cubeData.posCapacity",
        serialNumber: "cubeData.serialNumber",
        maxNum: "cubeData.maxNum",
        minNum: "cubeData.minNum",
        hangnailDetail: "cubeData.hangnailDetail",
        moduleType: "cubeData.moduleType",
        posInfo: "cubeData.posInfo",
        subSkuList: 'cubeData.subSkuList',

        //X
        xplaceType: "cubeData.xplaceType",
        xsurfaceType: "cubeData.xsurfaceType",
        xsurfaceWidthType: "cubeData.xsurfaceWidthType",
        xminSurfaceType: "cubeData.xminSurfaceType",
        xminSurfaceNum: "cubeData.xminSurfaceNum",
        xmaxSurfaceType: "cubeData.xmaxSurfaceType",
        xmaxSurfaceNum: "cubeData.xmaxSurfaceNum",
        xtargetSurfaceType: "cubeData.xtargetSurfaceType",
        xtargetSurfaceNum: "cubeData.xtargetSurfaceNum",
        xtargetPileType: "cubeData.xtargetPileType",
        xtargetPileNum: "cubeData.xtargetPileNum",
        xpileType: "cubeData.xpileType",
        xpilePos: "cubeData.xpilePos",
        xsurfaceNum: "cubeData.xsurfaceNum",
        xpileDirection: "cubeData.xpileDirection",
        xtargetSpace: "cubeData.xtargetSpace",

        //Y
        yplaceType: "cubeData.yplaceType",
        ysurfaceType: "cubeData.ysurfaceType",
        ysurfaceWidthType: "cubeData.ysurfaceWidthType",
        yminSurfaceType: "cubeData.yminSurfaceType",
        yminSurfaceNum: "cubeData.yminSurfaceNum",
        ymaxSurfaceType: "cubeData.ymaxSurfaceType",
        ymaxSurfaceNum: "cubeData.ymaxSurfaceNum",
        ytargetSurfaceType: "cubeData.ytargetSurfaceType",
        ytargetSurfaceNum: "cubeData.ytargetSurfaceNum",
        ytargetPileType: "cubeData.ytargetPileType",
        ytargetPileNum: "cubeData.ytargetPileNum",
        ypileType: "cubeData.ypileType",
        ypilePos: "cubeData.ypilePos",
        ysurfaceNum: "cubeData.ysurfaceNum",
        ypileDirection: "cubeData.ypileDirection",
        ytargetSpace: "cubeData.ytargetSpace",

        //Z
        zplaceType: "cubeData.zplaceType",
        zsurfaceType: "cubeData.zsurfaceType",
        zsurfaceWidthType: "cubeData.zsurfaceWidthType",
        zminSurfaceType: "cubeData.zminSurfaceType",
        zminSurfaceNum: "cubeData.zminSurfaceNum",
        zmaxSurfaceType: "cubeData.zmaxSurfaceType",
        zmaxSurfaceNum: "cubeData.zmaxSurfaceNum",
        ztargetSurfaceType: "cubeData.ztargetSurfaceType",
        ztargetSurfaceNum: "cubeData.ztargetSurfaceNum",
        ztargetPileType: "cubeData.ztargetPileType",
        ztargetPileNum: "cubeData.ztargetPileNum",
        zpileType: "cubeData.zpileType",
        zpilePos: "cubeData.zpilePos",
        zsurfaceNum: "cubeData.zsurfaceNum",
        zpileDirection: "cubeData.zpileDirection",
        ztargetSpace: "cubeData.ztargetSpace",
        xPileSurfaceWidth: "cubeData.xPileSurfaceWidth",
        xPileSurfaceHeight: "cubeData.xPileSurfaceHeight",
        xPileSurfaceDepth: "cubeData.xPileSurfaceDepth",
        yPileSurfaceWidth: "cubeData.yPileSurfaceWidth",
        yPileSurfaceHeight: "cubeData.yPileSurfaceHeight",
        yPileSurfaceDepth: "cubeData.yPileSurfaceDepth",
        zPileSurfaceWidth: "cubeData.zPileSurfaceWidth",
        zPileSurfaceHeight: "cubeData.zPileSurfaceHeight",
        zPileSurfaceDepth: "cubeData.zPileSurfaceDepth",
        specialAttr: "cubeData.specialAttr",
        warningEnumSet: "cubeData.warningEnumSet"
    },

    getFromGoodsKeyMap: {
        weight: "goods[0].wareInfoVO.weight",
        wareTag: "goods[0].cubeData.wareTag",
        maxSurfaceDepth: "goods[0].cubeData.maxSurfaceDepth",
        wareSizeSource: "goods[0].cubeData.wareSizeSource",
        sourceDisplayWareWidth: "goods[0].cubeData.sourceDisplayWareWidth",
        sourceDisplayWareHeight: "goods[0].cubeData.sourceDisplayWareHeight",
        sourceDisplayWareDepth: "goods[0].cubeData.sourceDisplayWareDepth",
        wareHighLightMap: "goods[0].wareInfoVO.wareHighLightMap",
        wareOperType: "goods[0].wareInfoVO.wareOperType",
        skuId: "goods[0].wareInfoVO.skuId",
        title: "goods[0].wareInfoVO.title",
        itemNum: "goods[0].wareInfoVO.itemNum",
        rfId: "goods[0].wareInfoVO.rfId",
        specInfo: "goods[0].wareInfoVO.specInfo",
        basicUnit: "goods[0].wareInfoVO.basicUnit",
        width: "goods[0].wareInfoVO.width",
        height: "goods[0].wareInfoVO.height",
        depth: "goods[0].wareInfoVO.depth",
        categoryName: "goods[0].wareInfoVO.categoryName",
        wareCat: "goods[0].wareInfoVO.wareCat",
        smallCatName: "goods[0].wareInfoVO.smallCatName",
        middleCatName: "goods[0].wareInfoVO.middleCatName",
        brandName: "goods[0].wareInfoVO.brandName",
        begrew: "goods[0].wareInfoVO.begrew",
        backColor: "goods[0].cubeData.backColor",
        boxHeight: "goods[0].cubeData.boxHeight",
        boxWidth: "goods[0].cubeData.boxWidth",
        boxDepth: "goods[0].cubeData.boxDepth",
        boxTotal: "goods[0].cubeData.boxTotal",
        imgUri: "goods[0].wareInfoVO.imgUri",
        realImgUri: "goods[0].wareInfoVO.realImgUri",
        wareImgUri: "goods[0].wareInfoVO.wareImgUri",
        wareImgMap: "goods[0].wareInfoVO.wareImgMap",
        wareBoxedImgMap: "goods[0].wareInfoVO.wareBoxedImgMap",
        showWareWidth: "goods[0].cubeData.showWareWidth",
        wareDisplayFlag: "goods[0].cubeData.wareDisplayFlag",
        showWareHeight: "goods[0].cubeData.showWareHeight",
        showWareDepth: "goods[0].cubeData.showWareDepth",
        showXPileWareWidth: "goods[0].cubeData.showXPileWareWidth",
        showXPileWareHeight: "goods[0].cubeData.showXPileWareHeight",
        showXPileWareDepth: "goods[0].cubeData.showXPileWareDepth",
        showYPileWareWidth: "goods[0].cubeData.showYPileWareWidth",
        showYPileWareHeight: "goods[0].cubeData.showYPileWareHeight",
        showYPileWareDepth: "goods[0].cubeData.showYPileWareDepth",
        showZPileWareWidth: "goods[0].cubeData.showZPileWareWidth",
        showZPileWareHeight: "goods[0].cubeData.showZPileWareHeight",
        showZPileWareDepth: "goods[0].cubeData.showZPileWareDepth",
        displayWareWidth: "goods[0].cubeData.displayWareWidth",
        displayWareHeight: "goods[0].cubeData.displayWareHeight",
        displayWareDepth: "goods[0].cubeData.displayWareDepth",
        displayWareWeight: "goods[0].cubeData.displayWareWeight",
        nestingHeight: "goods[0].cubeData.nestingHeight",
        nestingWidth: "goods[0].cubeData.nestingWidth",
        nestingDepth: "goods[0].cubeData.nestingDepth",
        extendFront: "goods[0].cubeData.extendFront",
        yfingerSpace: "goods[0].cubeData.yfingerSpace",
        xfingerSpace: "goods[0].cubeData.xfingerSpace",
        xextrusionLower: "goods[0].cubeData.xextrusionLower",
        xextendUpper: "goods[0].cubeData.xextendUpper",
        yextrusionLower: "goods[0].cubeData.yextrusionLower",
        yextendUpper: "goods[0].cubeData.yextendUpper",
        zextrusionLower: "goods[0].cubeData.zextrusionLower",
        zextendUpper: "goods[0].cubeData.zextendUpper",
        bizPrice: "goods[0].wareInfoVO.bizPrice",
        produceArea: "goods[0].wareInfoVO.produceArea"
    },

    goodsDefaultKeyMap: {
        usePartition: "posDefaultValue.usePartition",
        xplaceType: "posDefaultValue.xplaceType",
        xtargetSurfaceType: "posDefaultValue.xtargetSurfaceType",
        xtargetPileType: "posDefaultValue.xtargetPileType",
        yplaceType: "posDefaultValue.yplaceType",
        ytargetSurfaceType: "posDefaultValue.ytargetSurfaceType",
        ytargetPileType: "posDefaultValue.ytargetPileType",
        zplaceType: "posDefaultValue.zplaceType",
        ztargetSurfaceType: "posDefaultValue.ztargetSurfaceType",
        ztargetPileType: "posDefaultValue.ztargetPileType"
    }
};

export default goodsConfig;
